import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppURL } from './app.url';
import { AuthGuard } from './guards/auth.guards';

const routes: Routes = [
  {
    path: AppURL.account,
    loadChildren: () => import('./module/account/account.module').then(m => m.AccountModule),
  },
  {
    path: AppURL.home,
    loadChildren: () => import('./module/home/home.module').then(m => m.HomeModule),
    canActivateChild: [AuthGuard]
  },
  {
    path: AppURL.mangeForm,
    loadChildren: () => import('./module/manage-form/manage-form.module').then(m => m.ManageFormModule),
    canActivateChild: [AuthGuard]
  },
  {
    path: AppURL.response,
    loadChildren: () => import('./module/response/response.module').then(m => m.ResponseModule),
    canActivateChild: [AuthGuard]
  },
  {
    path: AppURL.abExperiment,
    loadChildren: () => import('./module/ab-experiment/ab-experiment.module').then(m => m.AbExperimentModule),
    canActivateChild: [AuthGuard]
  },
  {
    path: AppURL.formSurvey,
    loadChildren: () => import('./module/form-survey/form-survey.module').then(m => m.FormSurveyModule),
    canActivateChild: [AuthGuard]
  },
  {
    path: AppURL.form,
    loadChildren: () => import('./module/form-survey/form-survey.module').then(m => m.FormSurveyModule),
  },
  {
    path: AppURL.userGuide,
    loadChildren: () => import('./module/user-guide/user-guide.module').then(m => m.UserGuideModule),
    canActivateChild: [AuthGuard]
  },
  {
    path: '**',
    redirectTo: AppURL.account,
    pathMatch: 'full'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
